<template>
  <div class="image-ad-container">
      <el-carousel class="carousel" trigger="click" :height="imgHeight + 'px'">
        <el-carousel-item
          v-for="(v, i) in Array2(imgList,type)"
          :key="i"         
        >
          <ul
            class="cap-goods-layout__container"
            :class="{
              'one-column': type === '1',
              'two-column': type === '2',
              'three-column': type === '3',
            }"
          >
          <li
            class="cap-goods-layout__wrapper"
            v-for="(v2, i2) in v"
            :key="i2"
             @click="toUrl(v2.url)"
          >
            <div class="img-ad-wrapper">
              <img
                class="img"
                :src="v2.src"
                ref="image"
                alt="图片广告"
              />
              <!-- <span class="text" v-show="v2.text">{{ v2.text }}</span> -->
            </div>
          </li>
          </ul>
        </el-carousel-item>
      </el-carousel>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "1"
    },
    imgList: {
      type: Array,
      default: () => {}
    },
  },
  components: {},
  data() {
    return {
      imgHeight: 126
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    toUrl() {},
    formatArray(data, num) {
      num = parseInt(num);
      var dataList2 = []
      for (var i = 0, len = data.length; i < len; i += num) {
        dataList2.push(data.slice(i, i + num))
      }
      return dataList2
    },    
    Array2(imgList,type){
      var imgList2=[];
      imgList2 = this.formatArray(imgList, type)
      console.log("imgList2:",imgList2);
      return imgList2;
    },
  }
};
</script>
<style lang="scss" scoped>
.image-ad-container {
  padding: 15px;
  .img-ad-wrapper {
    position: relative;
  }
  .img {
    width: 100%;
    height: 100%;
    font-size: 0;
    margin: 0 auto;
  }
  .text {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    text-align: center;
    background-color: rgba(51, 51, 51, 0.8);
    color: #fff;
    font-size: 14px;
    height: 36px;
    line-height: 36px;
  }

  .img-list {
    .list-item {
      position: relative;
      font-size: 0;
    }

    .radius {
      border-radius: 10px;
    }
  }
}
.cap-goods-layout__wrapper {
  position: relative;
  min-height: 50px;
  color: #333;
  box-sizing: border-box;
  overflow: hidden;
  line-height: 16px;
  .cap-goods-layout__item {
    background-color: #fff;
    margin: 5px;
    &.radius {
      border-radius: 10px;
    }
  }
  &.radius {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
}
.cap-goods-layout__container {
  height: 100%;
  &.one-column {
    display: flex;
    flex-wrap: wrap;
    flex-direction: flex-start;
    justify-content: space-between;
    .cap-goods-layout__wrapper {
      width: 100%;
    }
  }
  &.two-column {
    display: flex;
    flex-wrap: wrap;
    flex-direction: flex-start;
    justify-content: space-between;
    .cap-goods-layout__wrapper {
      width: 48%;
    }
  }
  &.three-column {
    display: flex;
    flex-wrap: wrap;
    flex-direction: flex-start;
    .cap-goods-layout__wrapper {
      width: 31%;
      margin: 0 1%;
    }
  }
}
.carousel{ height: auto;}
</style>
